import { Box } from '@mui/material'
import { useMediaQuery, useTheme } from '@mui/material'
import { NumberFieldOrSpinner } from '~/components/number-spinner-field'
import { useCropModalContext } from '../context/crop-modal-context'
import { DESKTOP_BREAKPOINT } from '~/common/constants/layout-constants'

export const CropCountField = ({ onCountChange }) => {
  const theme = useTheme()
  const isDesktop = useMediaQuery(theme.breakpoints.up(DESKTOP_BREAKPOINT))
  const { count } = useCropModalContext()

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        flexWrap: 'wrap',
        '& .MuiButton-root': { height: { xs: '40px' } }
      }}
    >
      <NumberFieldOrSpinner
        isDesktop={isDesktop}
        label="Plant count"
        min={1}
        value={count}
        onValueChange={onCountChange}
      />
    </Box>
  )
}
